export type NbComponentShape = 'rectangle' | 'semi-round' | 'round';
